























import Vue, { PropType } from 'vue';
import { urlFor } from '@/config/sanity';
import LargeButton from '@/models/largeButton';
import InsuranceIcon from '@/assets/figma/FORSIKRINGER.svg';
import PensionIcon from '@/assets/figma/PENSJON IKON.svg';
import EmployeeHandbookIcon from '@/assets/figma/PERSONALHANDBOK IKON.svg';
import SocialIcon from '@/assets/figma/SOSIALT.svg';

export default Vue.extend({
  name: 'LargeButtonsPanel',
  components: {
    InsuranceIcon,
    PensionIcon,
    EmployeeHandbookIcon,
    SocialIcon,
  },
  props: {
    buttons: {
      type: Array as PropType<Array<LargeButton>>,
      required: true,
    },
  },
  methods: {
    urlFor,
    goToPage(url: string) {
      this.$router.push(`/om-oss/${url}`);
    },
  },
});
